import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Geoposition } from '@awesome-cordova-plugins/geolocation/ngx';
import { Guid } from '@models/guid';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

enum LocationProxyEvent {
  idle,
  sending,
  error
}

@Injectable()
export class PositionProxyService {
  private lastPosition: Geoposition = null;

  private resourceUid: Guid = null;

  private lastError: any = null;

  private readonly _state = new BehaviorSubject<LocationProxyEvent>(null);

  private readonly _isRunning = new BehaviorSubject(false);
  get isRunning(): boolean {
    return this._isRunning.value;
  }

  constructor(private httpClient: HttpClient) {}

  init(uid: Guid) {
    this.resourceUid = uid;
  }

  start() {
    if (this.isRunning) {
      return;
    }

    this._isRunning.next(true);

    if (this.resourceUid !== null && this.lastPosition !== null) {
      this.sendPosition();
    }
  }

  stop() {
    this._isRunning.next(false);
  }

  updatePosition(position: Geoposition) {
    const positionChanged: boolean = position !== this.lastPosition;
    this.lastPosition = position;
    if (positionChanged && this.isRunning) {
      this.sendPosition();
    }
  }

  private sendPosition() {
    const isValid = this.lastPosition?.coords;

    if (isValid) {
      this._state.next(LocationProxyEvent.sending);
      this.httpClient
        .post(
          'api/Location/ForVehicle',
          {
            resourceUid: this.resourceUid,
            coordX: this.lastPosition.coords.latitude,
            coordY: this.lastPosition.coords.longitude,
            coordZ: this.lastPosition.coords.altitude
          },
          { responseType: 'text' }
        )
        .pipe(
          tap(() => this._state.next(LocationProxyEvent.idle)),
          catchError((err: any, caught: Observable<string>) => this.onError(err, caught))
        )
        .subscribe();
    }
  }

  private onError(err: any, caught: Observable<string>): Observable<string> {
    this.lastError = err;
    this._state.next(LocationProxyEvent.error);
    return of(null);
  }
}
